<footer class="main-footer">
    <div class="pull-right hidden-xs">
        <b>Version</b> 2.3.1
    </div>
    <p>© RightWatts Solutions Private Limited. All Rights Reserved </p>
</footer>